import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // 引入路由
import App from './App.jsx';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    {/* 用BrowserRouter包裹整个App，提供路由上下文 */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);